<template>
  <div :class="['pageModule', { not_div: !isShow }]">
    <div class="bgc top-box">
      <div class="title">
        <div class="sort_son_title">{{ itemTitle }}</div>
        <!-- tabs切换 -->
        <div v-if="!$store.state.unionReport" class="wrap-tab">
          <a-tabs
            :active-key="tabActive"
            class="setmodel-tab"
            @change="changeTab"
          >
            <a-tab-pane
              v-for="(item, index) in selectList"
              :key="index"
              :tab="item"
            />
          </a-tabs>
        </div>
        <div class="right_div">
          <a-button
            v-if="tableData && tableData.length"
            class="btn"
            type="primary"
            ghost
            @click="importTo"
          >
            {{ $t('exam.downbtn') + itemTitle + $t('exam.biao') }}
          </a-button>
        </div>
      </div>
      <NotData v-if="!isShow && !loading" />
      <!-- 柱状图 -->
      <div v-else class="top-box-cheat">
        <div :id="chartId" class="chartAvg"></div>
      </div>
    </div>
    <div v-show="isShow" class="middle-box">
      <!-- 雷达图 -->
      <div v-if="seId == 0 && radarAvgShow" class="bgc left-radar">
        <div :id="radarId" class="radarAvg"></div>
      </div>
      <!-- 表格 -->
      <div ref="rightTable" class="bgc right-table">
        <a-table
          :columns="columns"
          :pagination="false"
          :data-source="tableData"
          :scroll="{ y: yHeight }"
          :row-class-name="
            record => (record.classId == classId ? 'current' : '')
          "
          row-key="classId"
        />
      </div>
    </div>
    <!-- 折线统计图 -->
    <div class="bgc bottom-box">
      <div class="sort_son_title">
        {{
          type == 'score' ? this.$t('exam.sortListTotal[4]') : '均位离差分析'
        }}
      </div>
      <NotData v-if="!isShow && !loading" />
      <Deviation v-else :id="type" ref="devs" :data="chartObj" />
    </div>

    <!-- <div v-if="isShow" class="not_data">
      <img src="@static/img/notdata.png" alt="" />
      <p>暂无图表</p>
    </div> -->
    <!-- <gaid v-else /> -->
  </div>
</template>
<script>
  import axios, { getCookie, isUnion } from '@utils'
  import * as echarts from 'echarts'
  import ApiXy from '@lib/api.js'
  import Deviation from '@view/dateCenter/details/total/deviation.vue' // 折线统计图
  import { getCol } from '@utils/unite.js'

  export default {
    name: 'Overview',
    components: {
      Deviation
      // gaid
    },
    props: {
      // show: {
      //   type: Boolean,
      //   default: true
      // },
      // id: {
      //   type: String,
      //   default: ''
      // },
      itemTitle: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'score' //score:均分分析   rank：均位分析
      },
      cache: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        radarAvgShow: true,
        loading: false,
        chartObj: {
          title: '',
          xTitle: [],
          yTitle: []
        }, // 折线统计图数据
        chartId: 'scoreAvg',
        radarId: 'scoreRadar',
        tableData: [],
        columns: getCol(`getavgscorelist${isUnion()}`) || [
          {
            title: this.$t('exam.classGroup'),
            dataIndex: 'classGroup',
            key: 'classGroup',
            width: 100
          },
          {
            title: this.$t('exam.className'),
            dataIndex: 'className',
            key: 'className',
            width: 100
          },
          {
            title: this.$t('exam.AvgScore'),
            dataIndex: 'AvgScore',
            key: 'AvgScore',
            width: 100
          },
          {
            title: this.$t('exam.BValue'),
            dataIndex: 'BValue',
            key: 'BValue',
            width: 100
          },
          {
            title: this.$t('exam.GradeRank'),
            dataIndex: 'GradeRank',
            key: 'GradeRank',
            width: 100
          },
          {
            title: this.$t('exam.GroupRank'),
            dataIndex: 'GroupRank',
            key: 'GroupRank',
            width: 100
          },
          {
            title: this.$t('exam.GroupScore'),
            dataIndex: 'GroupScore',
            key: 'GroupScore',
            width: 100
          }
          // {
          //   title: '年级平均排名',
          //   dataIndex: 'GradeOrderAvg',
          //   key: 'GradeOrderAvg',
          //   width: 100
          // }
        ],
        tabActive: 0,
        activeIndex: 0,
        selectList: [],
        isShow: true,
        seId: null,
        meId: null,
        classId: null,
        avgscoreList: [],
        barRadius: [6, 6, 0, 0],
        yHeight: 0,
        charts: null,
        chartsB: null
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.meId) {
            this.getavgscorelist()
          }
        },
        deep: true
      }
    },
    created() {},
    mounted() {
      let { meId, seId, dId, classId } = this.$route.query
      this.classId = classId
      this.seId = seId * 1
      this.meId = meId
      this.dId = dId
      this.chartId = this.type == 'score' ? 'scoreAvg' : 'rankAvg'
      this.radarId = this.type == 'score' ? 'radarAvg' : 'radarRank'
      this.yHeight = this.$refs.rightTable.offsetHeight - 40 - 46
      this.chartObj.title =
        this.type == 'score' ? this.$t('exam.overviewScore') : '离均位差'
      // 加载图表
      // this.dataLoad()
      this.getavgscorelist()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) {
          this.charts.resize()
          const radarIdBox = document.getElementById(this.radarId)
          if (radarIdBox) {
            this.chartsB.resize()
          }
        }
      },
      // customRow(record) {
      //   return {
      //     style: {
      //       background: record.classId == this.classId * 1 ? '#faad1447' : ''
      //     }
      //   }
      // },
      // 折线图展示
      brokenLineChart(xTitle, yTitle) {
        this.chartObj.yTitle = yTitle.map(item => item.toFixed(2))
        // 折线统计图数据
        this.chartObj.xTitle = xTitle
        this.$nextTick(() => {
          if (this.$refs.devs) this.$refs.devs.classDataD()
        })
      },
      // 柱状图展示
      classDataA(xTitle, yTitle, yAvg) {
        let that = this
        const lists = this.avgscoreList[this.tabActive] || {}
        const classList = lists.list || []
        const currentClass = classList.filter(
          ele => ele.classId == that.classId
        )
        let className = currentClass.length ? currentClass[0].className : ''
        //用于判断是校端还是局端
        // 基于准备好的dom，初始化echarts实例
        const chartBox = document.getElementById(this.chartId)
        if (!chartBox) return
        this.charts = echarts.init(chartBox)
        let chartObj = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: '#ddeeff'
              }
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'background: linear-gradient(322deg, #FDFEFF 0%, #F4F7FC 100%)',
            formatter: params => {
              const hoverClass = classList[params[0].dataIndex].scoreList
                ? classList[params[0].dataIndex].scoreList[0]
                : {}
              let { AvgScore, BValue, GradeRank, GroupScore, AvgRank } =
                hoverClass
              let relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>
                  ${classList[params[0].dataIndex].className}
                  </div>
                  <div class="toolTip">${this.$t('exam.studentNum')}：
                    ${classList[params[0].dataIndex].studentNum}
                  人
                  </div>
                  <div class="toolTip">${this.$t('exam.AvgScore')}：${
                AvgScore || '--'
              }</div>`

              if (!this.$store.state.unionReport) {
                relVal += `<div class="toolTip">${this.$t('exam.BValue')}：${
                  BValue || '--'
                }</div>
                <div class="toolTip">${this.$t('exam.GradeRank')}：${
                  GradeRank || '--'
                }</div>
                 <div class="toolTip">${this.$t('exam.GroupScore')}：${
                  GroupScore || '--'
                }</div>`
                // <div class="toolTip">年级平均排名：${
                //   GradeOrderAvg || '--'
                // }</div>`
              } else {
                relVal += `<div class="toolTip">${this.$t('exam.BValue')}：${
                  BValue || '--'
                }</div>
                <div class="toolTip">${this.$t('exam.unionRank')}：${
                  AvgRank || '--'
                }</div>`
              }
              return relVal
            }
          },
          grid: {
            top: 34,
            bottom: 26,
            left: '3.5%',
            right: 50
          },
          xAxis: {
            type: 'category',
            data: xTitle,
            axisTick: { show: false }, //是否展示y轴坐标刻度
            axisLabel: {
              color: '#666666'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#5f8eec'
              }
            },
            itemStyle: {
              color: '#666666'
            }
          },
          yAxis: {
            name: this.$t('exam.scoreNum'),
            nameTextStyle: {
              color: '#333'
            },
            axisTick: { show: false }, //是否展示y轴坐标刻度
            axisLabel: {
              color: '#666666'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#5f8eec'
              },
              itemStyle: {
                color: '#666666'
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ['#ddeeff', '#fff'],
                opacity: 0.3
              }
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              type: 'bar',
              color: '#5f8eec',
              itemStyle: {
                normal: {
                  color: params => {
                    let color = 'rgba(60,100,239,1)'
                    if (params.name == className) {
                      color = '#FF9F00'
                    }
                    return color
                  },
                  barBorderRadius: this.barRadius
                }
              },
              barMaxWidth: 40,
              barMinWidth: 20,
              barGap: 20,
              data: yTitle,
              AxisIndex: 1,
              markLine: {
                symbol: ['none', 'arrow'],
                data: [
                  {
                    type: 'average',
                    name: that.$t('exam.average'),
                    yAxis: yAvg
                  }
                ]
                // data: [{ type: 'average', name: '平均值' }]
              }
            }
          ]
        }
        // 绘制图表
        this.cScroll(chartObj, xTitle, 20)
        this.charts.setOption(chartObj)
        this.charts.on('click', param => {
          if (className == param.name) param.name = ''
          let arr = that.avgscoreList[that.tabActive].list || []
          arr = arr.filter(item => item.className == param.name)
          that.classId = arr[0] ? arr[0].classId : ''
          className = param.name

          that.charts.dispatchAction({
            type: 'dataZoom',
            dataIndex: param.dataIndex,
            seriesIndex: param.seriesIndex,
            className: param.name
          })
          that.creatViews()
        })
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                        m -75, 0
                                        a 75,75 0 1,0 150,0
                                        a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 30, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: 'rgba(203, 214, 255, 0.6)', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },
      creatViews() {
        const lists = this.avgscoreList[this.tabActive] || {}
        let currenTablist = lists.list || []
        let scoreList = currenTablist.filter(
          item => item.classId == this.classId
        ) //过滤取当前的班级
        if (!scoreList.length) {
          this.radarAvgShow = false
          return
        }
        this.radarAvgShow = true
        this.$nextTick(() => {
          this.creatRadarFc(scoreList)
        })
      },
      creatRadarFc(scoreList) {
        let j = scoreList[0].scoreList.filter(
          item => item.Name != '总分' || item.Name != '總分'
        )
        let subList = scoreList.length ? j : [] //过滤只留单科的
        const radarIdBox = document.getElementById(this.radarId)
        if (!radarIdBox || !subList.length) {
          this.radarAvgShow = false
          return
        }
        this.chartsB = echarts.init(radarIdBox)
        let data = [
          {
            name: scoreList[0].className,
            value: []
          }
        ]
        data[0].value = subList.map(item => item.AvgScore)
        let max = Math.max(...data[0].value)
        let list = subList.map(item => ({
          name: item.Name,
          max: max
        }))

        let option = {
          textStyle: {
            color: '#999',
            fontSize: 14
          },
          radar: {
            // shape: 'circle',
            indicator: list,
            name: {
              textStyle: {
                padding: [-5, -5]
              }
            }
          },
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: '#ddeeff'
              }
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'backdrop-filter: blur(10px)',
            formatter: params => {
              let relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${params.name}</div>`
              for (var i = 0, l = params.value.length; i < l; i++) {
                relVal += `<div class="toolTip">${list[i].name}：${params.value[i]}</div>`
              }
              return relVal
            }
          },
          series: [
            {
              name: scoreList[0].className,
              type: 'radar',
              areaStyle: {},
              data
            }
          ]
        }
        this.chartsB.setOption(option)
      },
      // 切换选择
      changeTab(key) {
        this.tabActive = key
        this.getData()
      },
      // // 概览图表数据加载
      // dataLoad() {
      //   this.getavgscorelist()
      // },
      // 获取均分分析
      getavgscorelist() {
        this.loading = true
        let { examIsActive = 1, classId, campusId } = this.$route.query
        // let obj = +examIsActive ? { schoolId: +schoolId } : {}
        let params = {
          meId: this.meId,
          classId,
          seId: this.seId,
          dId: this.dId,
          campusId
        }
        let urlObj = {
          score: [
            'getavgscorelist',
            'getavgscorelistUnion',
            'getavgscorelistSchoolUnion'
          ],
          rank: [
            'getavgranklist',
            'getavgranklistUnion',
            'getavgranklistSchoolUnion'
          ]
        }
        let url = urlObj[this.type][examIsActive]

        axios({
          url,
          params,
          loading: false,
          getCache: this.cache,
          cacheData: true
        })
          .then(res => {
            this.loading = false
            let list = res.data || []
            this.selectList = list.map(item => item.title)
            this.avgscoreList = list
            const lists = this.avgscoreList[this.tabActive] || {}
            this.isShow = lists.list ? true : false
            if (!lists.list) return
            this.getData()
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      getData() {
        const lists = this.avgscoreList[this.tabActive] || {}
        let list = lists.list || []
        list = list.filter(item => item.classId)
        let classList = list.map(item => item.classId)
        // let scoreList = list.scoreList || []
        let index = classList.indexOf(this.classId)
        this.activeIndex = index
        // this.activeIndex = index == -1 ? 0 : index
        let xTitle = list.map(item => item.className)
        let yTitle = list.map(item =>
          item.scoreList && item.scoreList.length
            ? item.scoreList[0].AvgScore
            : 0
        )
        let yAvg =
          list.length && list[0].scoreList && list[0].scoreList.length
            ? list[0].scoreList[0].GradeAvgScore || 0
            : 0
        let lineyTitle = list.map(item =>
          item.scoreList && item.scoreList.length
            ? item.scoreList[0].AvgScore - item.scoreList[0].GradeAvgScore
            : 0
        )

        this.brokenLineChart(xTitle, lineyTitle)
        this.classDataA(xTitle, yTitle, yAvg)
        let arr = list || []
        let nodataobj = {
          classId: '--',
          classGroup: '--',
          className: '--',
          studentNum: '--',
          AvgScore: '--',
          BValue: '--',
          GradeRank: '--',
          GroupRank: '--',
          GroupScore: '--',
          GradeAvgScore: '--',
          AvgRank: '--'
        }
        this.tableData = arr.map(item => {
          let { classGroup, className, studentNum, classId } = item
          let {
            AvgScore,
            BValue,
            GradeRank,
            GroupRank,
            GroupScore,
            GradeOrderAvg,
            AvgRank
          } =
            item.scoreList && item.scoreList.length
              ? item.scoreList[0]
              : nodataobj

          let obj = {
            classId,
            classGroup,
            className,
            studentNum,
            AvgScore,
            BValue,
            GradeRank,
            GroupRank,
            GroupScore,
            GradeOrderAvg,
            AvgRank
          }
          return obj
        })
        this.creatViews()
      },
      importTo() {
        let {
          meId,
          seId,
          dId,
          classId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let urlObj = {
          score: [
            'exportavgscoretable',
            'exportavgscoretableUnion',
            'exportavgscoretableSchoolUnion'
          ],
          rank: [
            'exportavgranktable',
            'exportavgranktableUnion',
            'exportavgranktableSchoolUnion'
          ]
        }
        let queryParams = {
          meId,
          seId,
          dId,
          classId,
          campusId
        }
        let queryList = []
        for (let q in queryParams) {
          if (queryParams[q] !== undefined) {
            queryList.push(`${q}=${queryParams[q]}`)
          }
        }
        let union = urlObj[this.type][examIsActive]
        let api = ApiXy.defaulteApi.path[union]
        let url =
          `${ApiXy.defaulteApi.host}${api}` +
          '?' +
          queryList.join('&') +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  /deep/.current {
    background: rgba(60, 100, 239, 0.2);
    td {
      background: none !important;
    }
  }
  /deep/.ant-tabs-ink-bar {
    display: none !important;
  }
  // Tab切换
  .wrap-tab {
    height: 30px;
    overflow: hidden;
    flex: 1;

    .setmodel-tab {
      /deep/.ant-tabs-bar {
        border: none;
        .ant-tabs-tab {
          height: 30px;
          line-height: 30px;
          min-width: 88px;
          border-radius: 15px;
          padding: 0 16px;
          margin-right: 8px;
          font-weight: 400;
          color: #4e5969;
          font-size: @font-size-base;
        }
        .ant-tabs-tab-active {
          border: none;
          background: #f2f3f8;
          color: @primary-color;
        }
      }
    }
  }

  .top-box {
    margin-bottom: @padding-sm;
    .top-box-cheat {
      min-height: 285px;
      .chartAvg {
        height: 400px;
      }
    }
  }
  .middle-box {
    margin-bottom: @padding-sm;
    display: flex;
    .left-radar {
      min-width: 27%;
      min-height: 287px;
      margin-right: @padding-sm;
      .radarAvg {
        width: 100%;
        height: 100%;
      }
    }
    .right-table {
      // width: 73%;
      max-height: 287px;
      overflow-y: auto;
      // padding: 20px 16px;
    }
  }
  // .bottom-box {
  // height: 352px;
  // }

  .not_div {
    padding-top: 1px;
    min-height: 400px;
    position: relative;
    overflow: hidden;

    // background-color: #fafafa;
    // box-shadow: none;
    // border-radius: none;
    .not_data {
      width: 300px;
      height: 250px;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      p {
        margin-top: 10px;
        text-align: center;
      }
      img {
        width: 100%;
      }
    }
  }
  .pageModule {
    width: 100%;
    min-height: 300px;
  }
</style>
